import React from 'react';
import FPActionButton from 'UI/components/atoms/FPActionButton';
import { getId } from 'UI/utils';

/**
 * @param {Object} props
 * @param {Array<ActionButtonsTypes>} [props.buttons]
 */
const CustomActionsMapper = ({ buttons }) =>
  buttons.map(
    ({ show = true, ...rest }) => show && <FPActionButton key={getId()} size="small" {...rest} />
  );

CustomActionsMapper.defaultProps = {
  buttons: []
};

export default CustomActionsMapper;
